<template>
  <div class="invoice-choose-apply">
    <apply-address
      :data="addressInfos"
      :select.sync="selectedAddress"
      @update-info="updateAddressInfo"
    ></apply-address>
    <apply-invoice-info :info="invoiceInfo" @update-info="updateInvoiceInfo"> </apply-invoice-info>
    <apply-order-list
      :address-info="curSelectAddress"
      :invoice-info="invoiceInfo"
    ></apply-order-list>
  </div>
</template>

<script>
import ApplyAddress from './components/apply-address'
import ApplyInvoiceInfo from './components/apply-invoice-info'
import ApplyOrderList from './components/apply-order-list'

export default {
  name: 'ChooseApply',
  components: { ApplyAddress, ApplyInvoiceInfo, ApplyOrderList },
  data() {
    return {
      addressInfos: [],
      selectedAddress: 0,
      invoiceInfo: {
        invoiceType: 1,
        invoiceUnit: 1
      }
    }
  },
  computed: {
    curSelectAddress() {
      if (this.addressInfos.length === 0) {
        return null
      } else {
        return this.addressInfos[this.selectedAddress]
      }
    }
  },
  created() {
    if (this.$route.query.orgName) {
      this.$set(this.invoiceInfo, 'invoiceOrgName', this.$route.query.orgName)
    }
    if (this.$route.query.orgId) {
      this.getUserAddressInfo()
      this.getInvoiceOrganization()
    } else {
      this.$router.push({ name: 'ChooseList' })
    }
  },
  methods: {
    async getUserAddressInfo() {
      try {
        const { success, data } = await this.$post('user.getOrgAddressByOrgId', {
          theUserId: this.$route.query.orgId
        })
        if (success && data[0] && data[0].value && data[0].value.length > 0) {
          data[0].value.sort((a, b) => a.id - b.id)
          this.addressInfos = data[0].value
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getInvoiceOrganization() {
      const { success, data } = await this.$post('invoice.common.queryInvoiceOrganization', {
        request: { orgId: this.$route.query.orgId }
      })
      if (success && data[0] && Object.keys(data[0]).length !== 0) {
        if (!data[0].invoiceType) {
          data[0].invoiceType = 1
        }
        if (!data[0].invoiceOrgName) {
          data[0].invoiceOrgName = this.$route.query.orgName
        }
        if (!data[0].invoiceUnit) {
          data[0].invoiceUnit = 1
        }
        this.invoiceInfo = data[0]
      }
    },
    updateAddressInfo(val) {
      if (val.type === 'add') {
        this.addressInfos.push(val.payload)
      } else {
        const address = this.addressInfos.find(ele => {
          if (ele.id) {
            return ele.id === val.payload.id
          } else if (ele._id) {
            return ele._id === val.payload._id
          }
          return false
        })
        if (address) {
          Object.keys(val.payload).forEach(key => {
            address[key] = val.payload[key]
          })
        }
      }
    },
    updateInvoiceInfo(val) {
      Object.keys(val).forEach(key => {
        this.invoiceInfo[key] = val[key]
      })
      if (!this.invoiceInfo.id) {
        this.$set(this.invoiceInfo, '_id', 1)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.invoice-choose-apply {
  width: 100%;
  min-width: 980px;
}
</style>
